import { FC, ReactNode } from 'react'
import { DateTime } from 'luxon'
import { useDateTimeToLocaleString } from '@hooks/useDateTimeWithLocale'

type TitleProps = {
  children?: ReactNode
} & ({ date: DateTime } | { title: string })

export const Title: FC<TitleProps> = ({ children, ...props }) => {
  const localize = useDateTimeToLocaleString()({
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  })

  return (
    <div className="flex flex-row justify-between px-4 text-sm font-semibold text-neutral-800">
      <span>
        {'date' in props && props.date
          ? localize(props.date)
          : 'title' in props
          ? props.title
          : ''}
      </span>
      <div className="flex flex-row gap-2">{children}</div>
    </div>
  )
}
